<template>
  <b-card class="m-3">
    <template #header>
      <h6 class="mb-0 text-center">
        <span class="titulo-sagres font-weight-bold">Detalhes da Vaga</span>
        <btn-voltar />
      </h6>
    </template>
    <b-row>
      <b-col class="fieldColumn">
        <span><b>Código</b></span>
        <span class="pos-left">{{ cargo.codigo }}</span>
      </b-col>
      <b-col class="fieldColumn">
        <span><b>Nomenclatura</b> </span>
        <span class="pos-left">{{ cargo.nomenclatura }}</span>
      </b-col>
      <b-col class="fieldColumn">
        <span><b>Situação da Vaga</b> </span>
        <span class="pos-left">{{ cargo.situacao }}</span>
      </b-col>
    </b-row>
    <b-row class="mt-4">
      <b-col class="fieldColumn">
        <span><b>Tipo de Vínculo</b></span>
        <span class="pos-left">{{ cargo.vinculo }}</span>
      </b-col>
      <b-col class="fieldColumn">
        <span><b>Tipo de Regime Jurídico</b> </span>
        <span class="pos-left">{{ cargo.regimeJuridico }}</span>
      </b-col>
      <b-col class="fieldColumn">
        <span><b>Natureza do Cargo</b></span>
        <span class="pos-left">{{ cargo.natureza }}</span>
      </b-col>
    </b-row>
    <!-- <b-row class="mt-4">
      <b-col class="fieldColumn">
        <span><b>Especialidade</b></span>
        <span class="pos-left">{{ cargo.especialidade }}</span>
      </b-col>
      <b-col class="fieldColumn">
        <span><b>Área</b> </span>
        <span class="pos-left">{{ cargo.area }}</span>
      </b-col> 
    </b-row> -->
    <b-row class="mt-4">
      <b-col class="fieldColumn">
        <span><b>Escolaridade Exigida</b></span>
        <span class="pos-left">{{ cargo.escolaridade }}</span>
      </b-col>
      <b-col v-if="cargo.regimePrevidenciario" class="fieldColumn">
        <span><b>Regime Previdenciário</b> </span>
        <span class="pos-left">{{ cargo.regimePrevidenciario ? cargo.regimePrevidenciario : '-' }}</span>
      </b-col>
      <b-col v-else></b-col>
      <!-- <b-col class="fieldColumn">
        <span><b>Habilitação Exigida</b> </span>
        <span class="pos-left">{{ cargo.habilitacaoExigida ? cargo.habilitacaoExigida : '-' }}</span>
      </b-col> -->
      <b-col class="fieldColumn">
        <span><b>Quantidade de Vagas</b> </span>
        <span class="pos-left">{{ cargo.quantidadeVagas }}</span>
      </b-col>
    </b-row>
    <!-- <b-row class="mt-4">
      <b-col class="fieldColumn">
        <span><b>Idade Mínima</b></span>
        <span class="pos-left">{{ cargo.idadeMinima ? cargo.idadeMinima : '-' }}</span>
      </b-col>
      <b-col class="fieldColumn">
        <span><b>Idade Máxima</b> </span>
        <span class="pos-left">{{ cargo.idadeMaxima ? cargo.idadeMaxima : '-' }}</span>
      </b-col>
      <b-col class="fieldColumn">
        <span><b>Teto Remuneratório Específico</b> </span>
        <span class="pos-left">{{ cargo.tetoRemuneratorioEspecifico }}</span>
      </b-col>
    </b-row> -->
    <b-row class="mt-4">
      <b-col class="fieldColumn">
        <span><b>Situação no TCE-SE</b> </span>
        <span class="pos-left">{{ cargo.situacaoNoTCE }}</span>
      </b-col>
      <b-col v-if="cargo.cargaHoraria" class="fieldColumn">
        <span><b>Carga Horária Semanal</b> </span>
        <span class="pos-left">{{ cargo.cargaHoraria ? cargo.cargaHoraria : '-' }}</span>
      </b-col>
      <b-col v-else></b-col>
      <b-col></b-col>
    </b-row>
    <br /><br />
    <span><b>Histórico de Alterações</b></span>
    <b-table :busy="items.length < 1" :fields="fields" hover no-border-collapse :items="items"
      sort-by="IdPrestacaoConta" :sort-desc="true" striped small :per-page="perPage" :current-page="currentPage"
      class="mt-3">
      <template #table-busy>
        <div class="text-center text-dark">
          <b-spinner class="align-middle"></b-spinner>
          <strong class="loading-text">Carregando...</strong>
        </div>
      </template>
      <template v-slot:cell(actions)="row">
        <div v-if="false">
          <span class="">{{}}</span>
        </div>
        <div v-else class="actions-icons">
          <div class="wrapper-icon" @click="abrirModalDetalheAlteracao(row.item)">
            <font-awesome-icon icon="eye" />
            <div style="font-size: 12px">Detalhar</div>
          </div>
        </div>
      </template>
    </b-table>
    <table-pagination :total-rows="items.length" :per-page="perPage" @pageChange="pageChange"></table-pagination>
    <router-view :key="$route.fullPath"></router-view>
  </b-card>
</template>

<script>
import cargoService from "@/services/atos-pessoal/cargoService";
import TablePagination from '@/components/atos-pessoal/TablePagination.vue';
import BtnVoltar from '@/components/shared/BtnVoltar.vue'
import { UtilsTS } from '@/utilsts';

export default {
  name: "detalhes-cargo",
  components: { TablePagination, BtnVoltar },
  props: ["idCargo"],
  mixins: [UtilsTS],
  data() {
    return {
      cargo: {
        codigo: "",
        nomenclatura: "",
        regimeJuridico: "",
        regimePrevidenciario: "",
        natureza: "",
        especialidade: "",
        area: "",
        escolaridade: "",
        habilitacaoExigida: "",
        quantidadeVagas: "",
        idadeMinima: null,
        idadeMaxima: null,
        tetoRemuneratorioEspecifico: "",
        situacao: "",
        situacaoNoTCE: "",
        cargaHoraria: null,
        normativo: null,
      },
      isBusy: true,
      fields: [
        {
          key: "IdCargo",
          tdClass: "d-none",
          thClass: "d-none",
          sortable: false,
        },
        {
          key: "NrVersao",
          label: "Sequencial",
          tdClass: "align-middle",
          thClass: "align-center",
          sortable: true,
        },
        {
          key: "DeTipoModificacao",
          label: "Tipo de Modificação",
          tdClass: "align-middle",
          thClass: "align-center",
          sortable: true,
        },
        {
          key: "DeTipoAlteracaoNormativa",
          label: "Alteração Normativa",
          tdClass: "align-middle",
          thClass: "align-center",
          sortable: true,
        },
        {
          key: "DeJustificativa",
          label: "Justificativa",
          tdClass: "align-middle",
          thClass: "align-center",
          sortable: true,
        },
        {
          key: "DtAlteracao",
          label: "Data",
          tdClass: "align-middle",
          thClass: "align-center",
          sortable: true,
        },
        {
          key: "actions",
          label: "Ações",
          tdClass: ["align-middle", "col-actions"],
          thClass: "text-center",
          sortable: true,
        },
      ],
      items: [],
      perPage: 5,
      currentPage: 1,
    };
  },
  methods: {
    pageChange(value) {
      this.currentPage = value;
    },
    voltar() {
      this.$router.go(-1);
    },
    async loadData() {
      this.getCargo();
      const historicoCargo = await this.getHistoricoCargo();
      this.updateData(historicoCargo);
    },
    updateData(data) {
      this.items = data.map((item) => {
        item.DtAlteracao = this.formatData(item.DtAlteracao);
        return item;
      });
    },
    async getCargo() {
      const response = await cargoService.getCargo(this.idCargo);

      if (response && response.status == 200) {
        const c = response.data;
        this.cargo.codigo = c.DeCodigoCargo.toUpperCase();
        this.cargo.nomenclatura = c.DeNomenclaturaCargo.toUpperCase();
        this.cargo.vinculo = c.IdTipoVinculoNavigation.DeTipoVinculo.toUpperCase();
        this.cargo.regimeJuridico =
          c.IdTipoRegimeJuridicoNavigation.DeTipoRegimeJuridico.toUpperCase();
        if (c.IdTipoRegimePrevidenciarioNavigation != null) {
          this.cargo.regimePrevidenciario =
            c.IdTipoRegimePrevidenciarioNavigation.DeTipoRegimePrevidenciario.toUpperCase();
        }
        this.cargo.natureza = c.IdNaturezaCargoNavigation.DeNaturezaCargo.toUpperCase();
        this.cargo.especialidade = c.DeEspecialidade ? c.DeEspecialidade.toUpperCase() : '-';
        this.cargo.area = c.DeArea ? c.DeArea.toUpperCase() : '-';
        this.cargo.escolaridade =
          c.IdTipoEscolaridadeNavigation.DeTipoEscolaridade.toUpperCase();
        this.cargo.habilitacaoExigida = c.DeHabilitacaoExigida ? c.DeHabilitacaoExigida.toUpperCase() : '-';
        this.cargo.quantidadeVagas = c.NrQuantidadeVagas;
        this.cargo.idadeMinima = c.NrIdadeMinima;
        this.cargo.idadeMaxima = c.NrIdadeMaxima;
        this.cargo.tetoRemuneratorioEspecifico = c.DeTetoRemuneratorioEspecifico ? c.DeTetoRemuneratorioEspecifico.toUpperCase() : '-';
        this.cargo.situacao = c.IdSituacaoCargoNavigation.DeSituacaoCargo;
        this.cargo.situacaoNoTCE = c.IdSituacaoCargoTceNavigation.DeSituacao;
        this.cargo.normativo = c.Normativo;
        this.cargo.cargaHoraria = c.NrCargaHoraria;
      }
      else {
        this.$toast.error('Erro ao obter os dados do cargo');
        this.$router.push("/atos-pessoal/cargos/consulta");
      }
    },
    async getHistoricoCargo() {
      const response = await cargoService.getHistoricoCargo(this.idCargo);
      if (response && response.status == 200) {
        return response.data;
      }
      else {
        this.$toast.error('Erro ao obter o histórico do cargo');
      }
    },
    abrirModalDetalheAlteracao(item) {
      this.$router.push(
        "/atos-pessoal/cargos/" + this.idCargo + "/alteracao/" + item.IdCargo
      );
    },
    checkNumeroDeVagas() {
      let min = 1;
      let max = 99999;

      if (this.cargo.quantidadeVagas.toString().replace(".", "") > max)
        this.cargo.quantidadeVagas = max

      if (this.cargo.quantidadeVagas.toString().replace(".", "") < min)
        this.cargo.quantidadeVagas = min

      var rx = /(\d+)(\d{3})/;
      this.cargo.quantidadeVagas = String(this.cargo.quantidadeVagas).replace(/^\d+/, function (w) {
        while (rx.test(w)) {
          w = w.replace(rx, '$1.$2');
        }
        return w;
      });
    }
  },
  computed: {
    rows() {
      return this.items.length;
    },
  },
  async created() {
    await this.loadData();
    this.checkNumeroDeVagas();
  },
};
</script>

<style scoped>
.fieldColumn {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
</style> 
